import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CpfCnpjValidator } from 'ngx-cpf-cnpj';
import { AbstractCrudComponent } from '../../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { InformacaoFechamentoMarcacaoProcedimentoDTO } from '../../../dtos/informacao-fechamento-marcacao-procedimento-dto';
import { MarcacaoDTO } from '../../../dtos/marcacao-dto';
import { RelatorioDTO } from '../../../dtos/relatorio-dto';
import { ResponseDTO } from '../../../dtos/response-dto';
import { FechamentoMarcacao } from '../../../marcacao/fechamento-marcacao';
import { Marcacao } from '../../../marcacao/marcacao-procedimento/marcacao';
import { MarcacaoProcedimentoService } from '../../../marcacao/marcacao-procedimento/marcacao-procedimento.service';
import { MarcacaoPK } from '../../../marcacao/marcacao-procedimento/pks/marcacao-pk';
import { Medico } from '../../../medico/medico';
import { MedicoService } from '../../../medico/medico.service';
import { IndTitularPipe } from '../../../pipes/ind-titular-pipe';
import { Procedimento } from '../../../procedimento/procedimento';
import { ProcedimentoService } from '../../../procedimento/procedimento.service';
import { RelatorioProcedimentoService } from '../../../relatorio/procedimento/relatorio-procedimento.service';
import { CustomDateValidator } from '../../../validators/custom-date-validator';
import { Filial } from '../../../filial/filial';
import { FilialService } from '../../../filial/filial.service';

@Component({
  selector: 'app-localizar-atendimento-procedimento-list',
  templateUrl: './localizar-atendimento-procedimento-list.component.html',
  styleUrls: ['./localizar-atendimento-procedimento-list.component.css']
})
export class LocalizarAtendimentoProcedimentoListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['horaAtendimento', 'nomePaciente', 'indTitular', 'cpf', 'nomePlanoSaude', 'nomeProcedimento', 'status', 'detalhe', 'acoes'];

  formularioDeLocalizacaoDeExame: FormGroup;

  filtroMarcacao: MarcacaoDTO;

  usuarioLogado: ResponseDTO;

  ocultarOpcaoExcluir: boolean = true;

  listaFiliais: Filial[];

  listaMedicos: Medico[];

  listaProcedimentos: Procedimento[];

  constructor(private marcacaoProcedimentoService: MarcacaoProcedimentoService,
    private filialService: FilialService, router: Router, dialog: MatDialog, 
    private formBuilder: FormBuilder, private indTitularPipe: IndTitularPipe, 
    private relatorioService: RelatorioProcedimentoService, 
    private medicoService: MedicoService, private procedimentoService: ProcedimentoService) {

    super(router, dialog);

    this.filtroMarcacao = history.state.filtroMarcacao;

    this.usuarioLogado = JSON.parse(localStorage.getItem('currentUser') || '{}');

    this.configurarVisibilidadeOpcaoDeExcluir();

    this.listaFiliais = [];

    this.listaMedicos = [];

    this.listaProcedimentos = [];

    this.formularioDeLocalizacaoDeExame = this.formBuilder.group({
      idFilial: ['', [Validators.required]],
      dataMarcacao: [''],
      nomePaciente: ['', [Validators.minLength(3)]],
      cpf: ['', [CpfCnpjValidator.validate]],
      idMedico: [''],
      idProcedimento: [''],
    }, {
      validator: CustomDateValidator('dataMarcacao')
    });
  }

  ngOnInit() {

    this.listarFiliais();

    this.listarMedicos();

    this.listarProcedimentos();

    if (!this.filtroMarcacao) {
      this.filtroMarcacao = new MarcacaoDTO();
    }

    if (this.filtroMarcacao &&
      (this.filtroMarcacao.idFilial || this.filtroMarcacao.nomePaciente ||
        this.filtroMarcacao.cpf || this.filtroMarcacao.dataMarcacao ||
        this.filtroMarcacao.idMedico || this.filtroMarcacao.idProcedimento)) {

      this.formularioDeLocalizacaoDeExame.patchValue(this.filtroMarcacao);

      this.reloadData(this.filtroMarcacao);
    }

    super.ngOnInit();
  }

  reloadData(marcacaoDTO: MarcacaoDTO) {

    if (!marcacaoDTO.dataMarcacao && !marcacaoDTO.nomePaciente && !marcacaoDTO.cpf) {

      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Preencha um dos seguintes campos: Data, Paciente ou CPF.'
        }
      });

    } else {

      this.marcacaoProcedimentoService.procurarMarcacaoProcedimentoPorFiltroComProjecao(marcacaoDTO)
        .subscribe(data => {
          // console.log(data)

          const listaMarcacoes: Array<MarcacaoDTO> = [];

          data.forEach((element: any) => {
            listaMarcacoes.push(Object.assign(new MarcacaoDTO(), element));
          });

          this.data = listaMarcacoes;

          this.configurarformatacoes(this.data);

          this.configurarDataSource();

        }, error => {
          console.log(error);
        });
    }
  }
  configurarformatacoes
    (data: MarcacaoDTO[]) {

    data.forEach(
      (val, index) => {
        data[index].indTitular = this.indTitularPipe.transform(data[index].cpfTitular);
      });

    return data;
  }

  onSubmit() {
    this.filtroMarcacao = this.formularioDeLocalizacaoDeExame.value;

    this.reloadData(this.filtroMarcacao);
  }

  confirmDelete(marcacaoDTO: MarcacaoDTO) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(marcacaoDTO);
      }
    });
  }

  delete(marcacaoDTO: MarcacaoDTO) {
    this.marcacaoProcedimentoService.removerMarcacao(marcacaoDTO.getPkProcedimentoDaEntidade())
      .subscribe(
        data => {
          // console.log(data);

          this.filtroMarcacao = this.formularioDeLocalizacaoDeExame.value;

          this.reloadData(this.filtroMarcacao);
        },
        error => {
          console.log(error);
        });
  }

  details(marcacaoDTO: MarcacaoDTO) {

    const filtroAtual: MarcacaoDTO = this.formularioDeLocalizacaoDeExame.value;

    this.router.navigate(['detalharMarcacaoProcedimento'], {
      state: {
        marcacaoDTO: marcacaoDTO,
        filtroMarcacao: filtroAtual,
        paginaAnterior: 'localizaAtendimentoProcedimento',
      }
    });
  }

  imprimirAgendamento(marcacaoDTO: MarcacaoDTO) {

    const relatorioDTO: RelatorioDTO = new RelatorioDTO();
    if (marcacaoDTO.idFilial) {
      relatorioDTO.filial = new Filial();
      relatorioDTO.filial.id = marcacaoDTO.idFilial;
    }
    if (marcacaoDTO.idPaciente) {
      relatorioDTO.idPaciente = marcacaoDTO.idPaciente;
    }
    if (marcacaoDTO.idPlanoSaude) {
      relatorioDTO.idPlanoSaude = marcacaoDTO.idPlanoSaude;
    }
    if (marcacaoDTO.idProcedimento) {
      relatorioDTO.idProcedimento = marcacaoDTO.idProcedimento;
    }
    if (marcacaoDTO.dataMarcacao) {
      relatorioDTO.dataInicial = marcacaoDTO.dataMarcacao;
    }

    this.relatorioService.gerarRelatorioDeDadosDoAgendamento(relatorioDTO)
      .subscribe((response: BlobPart) => {
        const file = new Blob([response], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
  }

  listarFiliais() {
    this.filialService.semRelacionamento()
      .subscribe(data => {
        // console.log(data)
        this.listaFiliais = data;

      }, error => {
        console.log(error);
      });
  }
  
  cancelar(marcacaoDTO: MarcacaoDTO) {

    if (!marcacaoDTO.motivoCancelamentoMarcacao) {
      this.router.navigate(['cancelarMarcacao'], {
        state: {
          filtroMarcacao: this.formularioDeLocalizacaoDeExame.value,
          marcacaoDTO: marcacaoDTO,
          tipoMarcacao: 'TIPO_MARCACAO_EXAME',
          paginaAnterior: 'localizaAtendimentoProcedimento',
        }
      });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Marcação já cancelada!'
        }
      });
    }
  }

  executarAcaoDoStatusSelecionado(marcacaoDTO: MarcacaoDTO): void {

    if (marcacaoDTO) {

      if (marcacaoDTO.status === Marcacao.STATUS_AGENDADO) {

        this.fecharMarcacao(marcacaoDTO);

      } else if (marcacaoDTO.status === Marcacao.STATUS_CANCELADO) {

        this.irParaTelaDeCancelamento(marcacaoDTO);

      } else if (marcacaoDTO.status === Marcacao.STATUS_FINALIZADO) {

        this.irParaTelaDeFechamento(marcacaoDTO);

      }
    }
  }

  fecharMarcacao(marcacaoDTO: MarcacaoDTO): void {

    if (this.usuarioLogado && this.usuarioLogado.username) {
      const fechamentoMarcacao: FechamentoMarcacao = new FechamentoMarcacao();
      fechamentoMarcacao.loginUserFechamento = this.usuarioLogado.username;

      const pk: MarcacaoPK = marcacaoDTO.getPkProcedimentoDaEntidade();

      const infoFechamento: InformacaoFechamentoMarcacaoProcedimentoDTO = new InformacaoFechamentoMarcacaoProcedimentoDTO();
      infoFechamento.pkMarcacao = pk;
      infoFechamento.fechamentoMarcacao = fechamentoMarcacao;

      this.marcacaoProcedimentoService.fecharMarcacao(infoFechamento)
        .subscribe(data => {
          // console.log(data)

          this.filtroMarcacao = this.formularioDeLocalizacaoDeExame.value;

          this.reloadData(this.filtroMarcacao);

        }, error => {
          console.log(error);
        });

    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Não será possível fechar a Marcação. Usuário logado não encontrado!'
        }
      });
    }
  }

  irParaTelaDeFechamento(marcacaoDTO: MarcacaoDTO): void {
    this.router.navigate(['informacaoFechamento'], {
      state: {
        filtroMarcacao: this.formularioDeLocalizacaoDeExame.value,
        fechamentoMarcacao: marcacaoDTO.fechamentoMarcacao,
        paginaAnterior: 'localizaAtendimentoProcedimento',
      }
    });
  }

  irParaTelaDeCancelamento(marcacaoDTO: MarcacaoDTO): void {
    this.router.navigate(['informacaoCancelamento'], {
      state: {
        filtroMarcacao: this.formularioDeLocalizacaoDeExame.value,
        motivoCancelamentoMarcacao: marcacaoDTO.motivoCancelamentoMarcacao,
        paginaAnterior: 'localizaAtendimentoProcedimento',
      }
    });
  }

  configurarVisibilidadeOpcaoDeExcluir(): void {

    this.ocultarOpcaoExcluir = true;

    if ((this.usuarioLogado && this.usuarioLogado.perfil &&
      (this.usuarioLogado.perfil === 'ROLE_ADMIN' || this.usuarioLogado.perfil === 'ROLE_ROOT')
    ) ||
      this.usuarioLogado.username === 'thayna') {

      this.ocultarOpcaoExcluir = false;

    }
  }

  listarMedicos() {
    this.medicoService.listarComProjecao()
      .subscribe(data => {

        // console.log(data)
        this.listaMedicos = data;

      }, error => {
        console.log(error);
      });
  }

  listarProcedimentos() {
    this.procedimentoService.listarComProjecao()
      .subscribe(data => {

        // console.log(data)
        this.listaProcedimentos = data;

      }, error => {
        console.log(error);
      });
  }
}
